export const systemUnixEpochNow = () => Math.trunc(Date.now() / 1000);
export const systemClock = () => ({
    unixEpochNow: systemUnixEpochNow,
});
